/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IntegrationAccessConnectionsControllerFindAllQueryResponse, IntegrationAccessConnectionsControllerFindAll401, IntegrationAccessConnectionsControllerFindAll403 } from "../../models/integrationAccessController/IntegrationAccessConnectionsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { integrationAccessConnectionsControllerFindAll } from "../../clients/integration-accessService/integrationAccessConnectionsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const integrationAccessConnectionsControllerFindAllQueryKey = () => [{
  url: '/api/v1/integration-access-connections'
}] as const;
export type IntegrationAccessConnectionsControllerFindAllQueryKey = ReturnType<typeof integrationAccessConnectionsControllerFindAllQueryKey>;
export function integrationAccessConnectionsControllerFindAllQueryOptions(config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = integrationAccessConnectionsControllerFindAllQueryKey();
  return queryOptions<IntegrationAccessConnectionsControllerFindAllQueryResponse, ResponseErrorConfig<IntegrationAccessConnectionsControllerFindAll401 | IntegrationAccessConnectionsControllerFindAll403>, IntegrationAccessConnectionsControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return integrationAccessConnectionsControllerFindAll(config);
    }
  });
}

/**
 * @summary List the integration projects Document Crunch reads for the caller
 * {@link /api/v1/integration-access-connections}
 */
export function useIntegrationAccessConnectionsControllerFindAll<TData = IntegrationAccessConnectionsControllerFindAllQueryResponse, TQueryData = IntegrationAccessConnectionsControllerFindAllQueryResponse, TQueryKey extends QueryKey = IntegrationAccessConnectionsControllerFindAllQueryKey>(options: {
  query?: Partial<QueryObserverOptions<IntegrationAccessConnectionsControllerFindAllQueryResponse, ResponseErrorConfig<IntegrationAccessConnectionsControllerFindAll401 | IntegrationAccessConnectionsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? integrationAccessConnectionsControllerFindAllQueryKey();
  const query = useQuery({
    ...integrationAccessConnectionsControllerFindAllQueryOptions(config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<IntegrationAccessConnectionsControllerFindAll401 | IntegrationAccessConnectionsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}